const accessTokenKey = 'accessToken'
const refreshTokenKey = 'refreshToken'

export function readHealthcareAccessToken(): string | null {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem(accessTokenKey)
}

export function readHealthcareRefreshToken(): string | null {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem(refreshTokenKey)
}

export function readHealthcareAppsCode(): string | null {
  if (typeof window === 'undefined') return null
  const code = window.localStorage.getItem('appsCode')
  return code && String(code).trim() ? String(code).trim() : null
}
